import Vue from 'vue';
import Vuex from 'vuex';
import i18n from '../i18n';


Vue.use(Vuex);
import axios from 'axios';
const API_BASE_URL = process.env.VUE_APP_ENV === 'production' ? process.env.VUE_APP_API_URL :  process.env.VUE_APP_LOCAL_API_URL// Replace this with your Node.js API base URL
const API_MISC_URL = process.env.VUE_APP_ENV === 'production' ? process.env.VUE_APP_MISC_URL :  process.env.VUE_APP_LOCAL_MISC_URL// Replace this with your Node.js API base URL
const API_SERVICE_URL = process.env.VUE_APP_ENV === 'production' ? process.env.VUE_APP_SERVICE_URL :  process.env.VUE_APP_LOCAL_SERVICE_URL// Replace this with your Node.js API base URL
const API_REALTIME_URL = process.env.VUE_APP_ENV === 'production' ? process.env.VUE_APP_REALTIME_URL : process.env.VUE_APP_LOCAL_REALTIME_URL// Replace this with your Node.js API base URL

export default new Vuex.Store({
    state: {
        
        layout: 'app',
        is_show_sidebar: true,
        is_show_search: false,
        is_dark_mode: false,
        dark_mode: 'light',
        locale: null,
        menu_style: 'vertical',
        layout_style: 'full',
        countryList: [
            { code: 'zh', name: 'Chinese' },
            { code: 'da', name: 'Danish' },
            { code: 'en', name: 'English' },
            { code: 'fr', name: 'French' },
            { code: 'de', name: 'German' },
            { code: 'el', name: 'Greek' },
            { code: 'hu', name: 'Hungarian' },
            { code: 'it', name: 'Italian' },
            { code: 'ja', name: 'Japanese' },
            { code: 'pl', name: 'Polish' },
            { code: 'pt', name: 'Portuguese' },
            { code: 'ru', name: 'Russian' },
            { code: 'es', name: 'Spanish' },
            { code: 'sv', name: 'Swedish' },
            { code: 'tr', name: 'Turkish' }
        ],
        states: [],
        cities: [],
        pincodes: [],
        // Recent Activities
        recentActivities: [],
        activityStats: null,
        // Global Loading States
        loadingStates: {
            initializing: true,      // App first load
            authenticating: false,   // Checking/loading user data
            navigating: false        // Route changing
        }
    },
    mutations: {
        setLayout(state, payload) {
            state.layout = payload;
        },
        toggleSideBar(state, value) {
            state.is_show_sidebar = value;
        },
        toggleSearch(state, value) {
            state.is_show_search = value;
        },
        toggleLocale(state, value) {
            value = value || 'en';
            i18n.locale = value;
            localStorage.setItem('i18n_locale', value);
            state.locale = value;
        },

        toggleDarkMode(state, value) {
            //light|dark|system
            value = value || 'light';
            localStorage.setItem('dark_mode', value);
            state.dark_mode = value;
            if (value == 'light') {
                state.is_dark_mode = false;
            } else if (value == 'dark') {
                state.is_dark_mode = true;
            } else if (value == 'system') {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    state.is_dark_mode = true;
                } else {
                    state.is_dark_mode = false;
                }
            }

            if (state.is_dark_mode) {
                document.querySelector('body').classList.add('dark');
            } else {
                document.querySelector('body').classList.remove('dark');
            }
        },

        toggleMenuStyle(state, value) {
            //horizontal|vertical|collapsible-vertical
            value = value || '';
            localStorage.setItem('menu_style', value);
            state.menu_style = value;
            if (!value || value === 'vertical') {
                state.is_show_sidebar = true;
            } else if (value === 'collapsible-vertical') {
                state.is_show_sidebar = false;
            }
        },

        toggleLayoutStyle(state, value) {
            //boxed-layout|large-boxed-layout|full
            value = value || '';
            localStorage.setItem('layout_style', value);
            state.layout_style = value;
        },
        //Get Locations
        SET_STATES(state, states) {
        state.states = states;
        if(states.length > 0){
          localStorage.setItem('states', JSON.stringify(states));
        }
        
        },
        SET_CITIES(state, cities) {
        state.cities = cities;
        if(cities.length > 0){
          localStorage.setItem('cities', JSON.stringify(cities));
        }
        
        },
        SET_PINCODES(state, pincodes) {
        state.pincodes = pincodes;
        if(pincodes.length > 0){
          localStorage.setItem('pincodes', JSON.stringify(pincodes));
        }
        },
        // Activity mutations
        SET_RECENT_ACTIVITIES(state, activities) {
            state.recentActivities = activities;
            // Cache activities for 24 hours
            const cacheData = {
                activities: activities,
                timestamp: Date.now()
            };
            localStorage.setItem('recentActivities', JSON.stringify(cacheData));
        },
        ADD_RECENT_ACTIVITY(state, activity) {
            // Add to the beginning (latest first)
            state.recentActivities.unshift(activity);
            // Keep only last 50 activities to prevent memory issues
            if (state.recentActivities.length > 50) {
                state.recentActivities = state.recentActivities.slice(0, 50);
            }
            // Update cache
            const cacheData = {
                activities: state.recentActivities,
                timestamp: Date.now()
            };
            localStorage.setItem('recentActivities', JSON.stringify(cacheData));
        },
        SET_ACTIVITY_STATS(state, stats) {
            state.activityStats = stats;
        },
        CLEAR_OLD_ACTIVITIES(state) {
            // Clear activities older than today
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            state.recentActivities = state.recentActivities.filter(activity => {
                const activityDate = new Date(activity.time);
                activityDate.setHours(0, 0, 0, 0);
                return activityDate.getTime() === today.getTime();
            });
            
            // Update cache
            const cacheData = {
                activities: state.recentActivities,
                timestamp: Date.now()
            };
            localStorage.setItem('recentActivities', JSON.stringify(cacheData));
        },
        // Global Loading State Mutations
        SET_LOADING_STATE(state, { phase, value }) {
            state.loadingStates[phase] = value;
        }
    },
    getters: {
        layout(state) {
            return state.layout;
        },
        isGlobalLoading(state) {
            // Show loading if ANY phase is active
            return state.loadingStates.initializing ||
                   state.loadingStates.authenticating ||
                   state.loadingStates.navigating;
        }
    },
    actions: {
        async fetchStates({ commit }) {
            try {
              const localStates = localStorage.getItem('states');
              if (localStates) {
                commit('SET_STATES', JSON.parse(localStates));
              } else {
                const response = await axios.get(`${API_MISC_URL}/locations/states`);
                
                commit('SET_STATES', response.data);
              }
            } catch (error) {
              console.error('Error fetching states:', error);
            }
          },
          async fetchCities({ commit }) {
            try {
              const localCities = localStorage.getItem('cities');
              if (localCities) {
                commit('SET_CITIES', JSON.parse(localCities));
              } else {
                // Fetch cities from API
                const response = await axios.get(`${API_MISC_URL}/locations/cities`);
                commit('SET_CITIES', response.data);
              }
            } catch (error) {
              console.error('Error fetching cities:', error);
            }
          },
          async fetchPincodes({ commit }) {
            try {
              const localPincodes = localStorage.getItem('pincodes');
              if (localPincodes) {
                commit('SET_PINCODES', JSON.parse(localPincodes));
              } else {
                // Fetch pincodes from API
                const response = await axios.get(`${API_MISC_URL}/locations/pincodes`);
                commit('SET_PINCODES', response.data);
              }
            } catch (error) {
              console.error('Error fetching pincodes:', error);
            }
          },
          // Activity actions
          async fetchRecentActivities({ commit }) {
            try {
              // First, try to load from cache
              const cachedData = localStorage.getItem('recentActivities');
              if (cachedData) {
                const parsed = JSON.parse(cachedData);
                const now = Date.now();
                const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
                
                // Check if cache is still valid (less than 24 hours old)
                if (now - parsed.timestamp < oneDay) {
                  // Also check if activities are from today
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  
                  const todaysActivities = parsed.activities.filter(activity => {
                    const activityDate = new Date(activity.time);
                    activityDate.setHours(0, 0, 0, 0);
                    return activityDate.getTime() === today.getTime();
                  });
                  
                  if (todaysActivities.length > 0) {
                    commit('SET_RECENT_ACTIVITIES', todaysActivities);
                  }
                }
              }
              
              // Fetch fresh data from API
              const response = await axios.get(`${API_REALTIME_URL}/activities/recent`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                }
              });
              
              if (response.data.status && response.data.activities) {
                commit('SET_RECENT_ACTIVITIES', response.data.activities);
              }
            } catch (error) {
              console.error('Error fetching recent activities:', error);
              // If API fails, try to use cached data
              const cachedData = localStorage.getItem('recentActivities');
              if (cachedData) {
                const parsed = JSON.parse(cachedData);
                commit('SET_RECENT_ACTIVITIES', parsed.activities || []);
              }
            }
          },
          
          async fetchActivityStats({ commit }) {
            try {
              const response = await axios.get(`${API_REALTIME_URL}/activities/stats`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                }
              });
              
              if (response.data.status && response.data.stats) {
                commit('SET_ACTIVITY_STATS', response.data.stats);
              }
            } catch (error) {
              console.error('Error fetching activity stats:', error);
            }
          },
          
          // Called when a new activity is received via socket
          addRecentActivity({ commit }, activity) {
            commit('ADD_RECENT_ACTIVITY', activity);
          },
          
          // Clear old activities (called on app initialization)
          clearOldActivities({ commit }) {
            commit('CLEAR_OLD_ACTIVITIES');
          },
    },
    modules: {}
});
